import { BillingAccount, BillingUser } from "../../schema/types/account";
import { store } from "../../store";
import { BillingAccountCreateInput, BillingAccountCreateRequest, BillingAccountDetailInput } from "./create/input";
import { v4 as uuidv4 } from "uuid";

export function getDefaultBillingAccountCreateInput(): BillingAccountCreateInput {
  return {
    account: {
      tou: false,
      accountName: "",
      fullName: "",
      company: "",
      jobTitle: "",
      linkedin: "",
      phone: "",
    },
    address: {
      country: "United States",
      state: "",
      city: "",
      address1: "",
      address2: "",
      postalCode: "",
    },

    orgName: "",
    gvcName: "",
    locationNames: [],

    meta: {
      createdAccount: {
        disabled: false,
        id: "",
      },
      paymentMethod: {
        consented: false,
        canCreate: false,
      },
      formStep: "info",
    },
  };
}

export function inputToBillingAccount(values: BillingAccountCreateInput): BillingAccountCreateRequest {
  const userEmail = store.getState().user.email;

  const body: BillingAccountCreateRequest = {
    email: userEmail,
    accountName: values.account.accountName,
    fullName: values.account.fullName,
    extraInfo: {
      company: values.account.company,
      jobTitle: values.account.jobTitle,
    },
    phone: values.account.phone,
    address: {
      address1: values.address.address1,
      postalCode: values.address.postalCode,
      city: values.address.city,

      country: values.address.country,
    },
  };

  if (values.address.state) {
    body.address.state = values.address.state;
  }
  if (values.address.address2) {
    body.address.address2 = values.address.address2;
  }
  if (values.account.linkedin) {
    body.extraInfo.linkedin = values.account.linkedin;
  }

  return body;
}

export function billingAccountToDetailInput(account: BillingAccount, users: BillingUser[]): BillingAccountDetailInput {
  return {
    account: {
      accountName: account.accountName || "",
      fullName: account.fullName || "",
      company: account.extraInfo?.company || "",
      jobTitle: account.extraInfo?.jobTitle || "",
      linkedin: account.extraInfo?.linkedin || "",
      phone: account.phone || "",
    },
    address: {
      address1: account.address?.address1 || "",
      address2: account.address?.address2 || "",
      city: account.address?.city || "",
      country: account.address?.country || "",
      state: account.address?.state || "",
      postalCode: account.address?.postalCode || "",
    },
    alert: account.alert || {},
    hasAcceptedTerms: account.tou || false,
    users: (users || []).map((u) => ({ id: uuidv4(), ...u })),
    meta: {
      isDisabled: false,
    },
  };
}
